import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetQuickQuestions($id: ID!, $autoMessageId: ID!, $locale: String!) {
    partner(id: $id) {
      id
      quickQuestions(id: $autoMessageId, locale: $locale) {
        id
        questions
      }
    }
  }
`);
